import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import Marquee from "react-fast-marquee";


const Header = () => {
  const location = useLocation();
  // ---------------- GOOGLE TAG SCRIPT ----------------
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src =
      "https://www.googletagmanager.com/gtag/js?id=AW-11326138693";
    script1.async = true;
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-11326138693');
      `;
    document.head.appendChild(script2);
  }, []);
  // ----------------------------------------------------

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [showOpen, setShowOpen] = useState(false);
  const [showOpen1, setShowOpen1] = useState(false);

  const handleDivClick = () => {
    setShowOpen(!showOpen);
  };
  const handleDivClick1 = () => {
    setShowOpen1(!showOpen1);
  };

  const handleSearchToggle = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const handleMenuToggle = () => {
    const menuDropdown = document.getElementById("menuDropdown");
    const bootstrapCollapse = new window.bootstrap.Collapse(menuDropdown);
    bootstrapCollapse.toggle();
  };

  return (
  <div className="">
  <div className="container-fluid topheadmarquee py-1 fw-bold top_num_ber4">
    <div className="row align-items-center">

      {/* LEFT SIDE - ADDRESS */}
      <div className="col-12 col-md-6 col-lg-6 d-flex p-2 align-items-center">
        <i
          className="fa-solid fa-location-dot px-2"
          style={{ color: "#f28535" }}
        />
        <p className="phn_777 m-0">
          2A, Partap Spintex Street, Dukheri Road, Mohra - 133004
        </p>
		<i
          className="fa-solid fa-location-dot px-2"
          style={{ color: "#f28535" }}
        />
        <p className="phn_777 m-0">  
Kalpak Estate,Antop Hill,Mumbai-400037
        </p>
      </div>
	  

      {/* RIGHT SIDE */}
      <div className="col-12 col-md-6 col-lg-6">
        <div className="row">

          {/* PHONE */}
          <div className="col-12 col-sm-12 col-md-6 d-flex justify-content-md-end py-1">
            <div className="phn_777 d-flex align-items-center">
              <i className="fa-solid fa-phone mr-2" />
              <p className="m-0">
                +91 90537-77905, +91 90538-88905
              </p>
            </div>
          </div>

          {/* EMAIL */}
          <div className="col-12 col-sm-12 col-md-6 d-flex justify-content-md-start py-1">
            <div className="email_123 d-flex align-items-center">
              <i className="fa-solid fa-envelope-open-text mr-2" />
              <span>bioversalremedies@gmail.com</span>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
  
{/* RIGHT VERTICAL SOCIAL ICONS */}
<div className="floating-social-icons">
  <a
    href="https://www.facebook.com/people/Bioversal-Remedies-Pvt-Ltd/100080933517001/"
    target="_blank"
    rel="noreferrer"
    className="social-icon facebook"
  >
    <i className="fab fa-facebook-f"></i>
  </a>
  <a
    href="https://x.com/bioversal_22"
    target="_blank"
    rel="noreferrer"
    className="social-icon x"
  >
    <i className="fab fa-x-twitter"></i>
  </a>
  <a
    href="https://www.instagram.com/bioversal_remedies/"
    target="_blank"
    rel="noreferrer"
    className="social-icon instagram"
  >
    <i className="fab fa-instagram"></i>
  </a>
  <a
    href="https://www.linkedin.com/in/bioversal-remedies-851b82239?originalSubdomain=in"
    target="_blank"
    rel="noreferrer"
    className="social-icon linkedin"
  >
    <i className="fab fa-linkedin-in"></i>
  </a>
 <a
    href="https://in.pinterest.com/bioversalremedies/"
    target="_blank"
    rel="noreferrer"
    className="social-icon pinterest"
>
    <i className="fab fa-pinterest-p"></i>
</a>

</div>

<a href="https://api.whatsapp.com/send?phone=919053777905" target="_blank" class="whatsapp-float"><i class="fab fa-whatsapp"></i></a>
      <header className="header header-transparent rs-nav">
        <div className="sticky-header navbar-expand-lg">
          <div className="menu-bar clearfix">
            <div className="container-fluid clearfix main-header-hh1">
              <div className="menu-logo logo-dark">
                <NavLink to="/">
                  <img
                    src="/assets/images/bioversal-logo.png"
                    alt="Brand Logo"
                  />
                </NavLink>
              </div>

              <div
                className="menu-links navbar-collapse collapse justify-content-center align-items-center"
                id="menuDropdown"
              >
                <ul className="nav navbar-nav animate__animated animate__fadeInDown">
                  <li className="btn-border-hover" onClick={handleMenuToggle}>
                    <NavLink
                      to="/"
                      style={{ textDecoration: "none", fontSize: "14px" }}
                      className={
                        location.pathname === "/" ? "btn-white" : "btn-orange"
                      }
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className="btn-border-hover" onClick={handleMenuToggle}>
                    <NavLink
                      to="/company-overview"
                      style={{ textDecoration: "none", fontSize: "14px" }}
                      className={
                        location.pathname === "/" ? "btn-white" : "btn-orange"
                      }
                    >
                      About<i className=""></i>
                    </NavLink>
                  </li>
                  <li
                    className={
                      showOpen ? "open btn-border-hover" : "btn-border-hover"
                    }
                    onClick={handleDivClick}
                  >
                    <NavLink
                      to="#"
                      style={{ textDecoration: "none", fontSize: "14px" }}
                      className={
                        location.pathname === "/" ? "btn-white" : "btn-orange"
                      }
                    >
                      Pharma Franchise<i className="fas fa-plus"></i>
                    </NavLink>
                    <ul className="sub-menu">
                      <li className="add-menu-left">
                        <ul>
                          <li onClick={handleMenuToggle}>
                            <NavLink to="/pharma-franchise">
                              Pharma Franchise
                            </NavLink>
                          </li>
                          <li onClick={handleMenuToggle}>
                            <NavLink to="/pharma-franchise-companies">
                              Pharma Franchise Companies
                            </NavLink>
                          </li>
                          <li onClick={handleMenuToggle}>
                            <NavLink to="/pcd-pharma-franchise">
                              PCD Pharma Franchise
                            </NavLink>
                          </li>
                          <li onClick={handleMenuToggle}>
                            <NavLink to="/indian-pcd-pharma-companies">
                              Indian PCD Pharma Companies
                            </NavLink>
                          </li>
                          <li onClick={handleMenuToggle}>
                            <NavLink to="/pcd-pharma-companies">
                              PCD Pharma Companies
                            </NavLink>
                          </li>
                          <li onClick={handleMenuToggle}>
                            <NavLink to="/pcd-pharma-franchise-company">
                              PCD Pharma Franchise Company
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li className="btn-border-hover" onClick={handleMenuToggle}>
                    <NavLink
                      to="/product-list"
                      style={{ textDecoration: "none", fontSize: "14px" }}
                      className={
                        location.pathname === "/" ? "btn-white" : "btn-orange"
                      }
                    >
                      Our Products
                    </NavLink>
                  </li>
                  <li className="btn-border-hover" onClick={handleMenuToggle}>
                    <NavLink
                      to="/blog"
                      style={{ textDecoration: "none", fontSize: "14px" }}
                      className={
                        location.pathname === "/" ? "btn-white" : "btn-orange"
                      }
                    >
                      Blogs
                    </NavLink>
                  </li>
                  <li className="btn-border-hover" onClick={handleMenuToggle}>
                    <NavLink
                      to="/third-party-pharma-manufacturing"
                      style={{ textDecoration: "none", fontSize: "14px" }}
                      className={
                        location.pathname === "/" ? "btn-white" : "btn-orange"
                      }
                    >
                      Third Party Manufacturing
                    </NavLink>
                  </li>
                  <li
                    className={
                      showOpen1 ? "open btn-border-hover" : "btn-border-hover"
                    }
                    onClick={handleDivClick1}
                  >
                    <NavLink
                      to="javascript:;"
                      style={{ textDecoration: "none", fontSize: "14px" }}
                      className={
                        location.pathname === "/" ? "btn-white" : "btn-orange"
                      }
                    >
                      Gallery<i className="fas fa-plus"></i>
                    </NavLink>
                    <ul className="sub-menu left">
                      <li onClick={handleMenuToggle}>
                        <NavLink to="VisualAid">Visual-Aid</NavLink>
                      </li>
                      <li onClick={handleMenuToggle}>
                        <NavLink to="Product-Listing">Product-Picture</NavLink>
                      </li>
                      <li onClick={handleMenuToggle}>
                        <NavLink to="Promotion-Input">
                          Promotional-Inputs
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </ul>
                {/* <ul className="social-media">
                  <li>
                    <a
                      target="_blank"
                      href="https://www.facebook.com/"
                      className="btn btn-primary"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.google.com/"
                      className="btn btn-primary"
                    >
                      <i className="fab fa-google"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/"
                      className="btn btn-primary"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://twitter.com/"
                      className="btn btn-primary"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                </ul> */}
                <div className="menu-close" onClick={handleMenuToggle}>
                  <i className="ti-close">
                    <IoMdClose size={25} />
                  </i>
                </div>
              </div>

              <button
                className="navbar-toggler collapsed menuicon justify-content-end"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#menuDropdown"
                aria-controls="menuDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              {/* <div className="secondary-menu">
                <ul>
                  <li className="search-btn">
                    <button
                      id="quikSearchBtn"
                      type="button"
                      className="btn-link"
                      onClick={handleSearchToggle}
                    >
                      <i className="las la-search"></i>
                    </button>
                  </li>
                  <li className="num-bx">
                    <a href="tel:(+01)999888777">
                      <i className="fas fa-phone-alt"></i> (+01) 999 888 777
                    </a>
                  </li>
                  <li className="btn-area">
                    <NavLink
                      to="#"
                      className="btn btn-primary shadow cnct_btn1"
                    >
                      CONTACT US{" "}
                      <i className="btn-icon-bx fas fa-chevron-right"></i>
                    </NavLink>
                  </li>
                </ul>
              </div> */}
              <div className="nav-search-bar">
                <form action="#">
                  <input
                    name="search"
                    value=""
                    type="text"
                    className="form-control"
                    placeholder="Type to search"
                  />
                  <span>
                    <i className="ti-search"></i>
                  </span>
                </form>
                <span id="searchRemove" onClick={handleSearchToggle}>
                  <i className="ti-close"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
